module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.1dce1ee5.mp3";